import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import {
	getClientResourcesSearchModule,
	getModuleOneClient,
	getResourcesModuleClient,
} from '../../../Infrastructure/Store/clients/clients.action';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { getClient } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { selectClientState } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.selectors';

import { postRole, updateRole } from 'projects/access-control/src/app/Infrastructure/Store/role/role.actions';
import { select, Store } from '@ngrx/store';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';
import { TranslateService } from '@mangosoft/mango-layout';

import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { SearchResourcesService } from 'projects/access-control/src/app/Infrastructure/Services/search-resources.service';

interface DataModal {
	type: string;
	value: IRole;
}

interface translateModalRole {
	title: string;
	titleUpdate: string;
	textNotResources: string;
	name: string;
	description: string;
	client: string;
	titleFilter: string;
	module: string;
	resources: string;
	search: string;
	buttonSave: string;
	buttonCancel: string;
}
@Component({
	selector: 'app-modal-new-role',
	templateUrl: './modal-new-role.component.html',
	styleUrls: ['./modal-new-role.component.scss'],
})
export class ModalNewRoleComponent implements OnInit, OnDestroy {
	clients: Client[] = [];
	client: Client = {} as Client;
	modules: ModuleClient[] = [];
	title = '';
	moduleSelect: ModuleClient = {} as ModuleClient;
	subscriptionClient!: Subscription;
	subscriptionResources!: Subscription;
	resources: Resource[] = [];
	modeColum!: any;
	listResources: Resource[] = [];
	searchResource = '';
	loadingResources = true;
	selector = '.resourceSelector';
	getFullDataResource = false;
	columns = [{ name: 'name' }, { name: 'action' }, { name: 'path' }];
	formRole!: FormGroup;
	isModeSearch = false;
	i = 0;
	paginationResource: DataPagination = {} as DataPagination;
	translateModal: translateModalRole = {} as translateModalRole;
	subscriptionTranslate!: Subscription;
	subscriptionModule!: Subscription;
	showViewRoles = true;
	constructor(
		public dialogRef: MatDialogRef<ModalNewRoleComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DataModal,
		private store: Store,
		private fb: FormBuilder,
		private translate: TranslateService,
		private searchResourcesService: SearchResourcesService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		this.moduleSelect = {} as ModuleClient;
		this.dataForm();
		this.modeColum = ColumnMode.force;
		setTimeout(() => {
			this.dataTranslate();
			this.store.dispatch(getClient());
			this.getClients();
			this.validateRouces();
			this.title = this.translateModal.title;
			if (this.data.type === 'update') {
				this.title = this.translateModal.titleUpdate;
				this.showViewRoles = false;
				this.formRole.patchValue({
					...this.data.value,
				});
			}
		});
	}
	dataForm() {
		this.formRole = this.fb.group({
			name: ['', [Validators.required]],
			description: [''],
		});
	}

	selectedModule() {
		this.resources = [];
		this.getFullDataResource = false;
		this.store.dispatch(
			getResourcesModuleClient({
				url: `${this.moduleSelect.relationships.self}?_size=20&_page=1`,
				pkClient: this.client.pk,
				skClient: this.client.sk,
			})
		);
		this.loadingResources = true;
	}

	selectClient(client: any) {
		this.listResources = [];
		this.store.dispatch(getModuleOneClient({ pk: client.value.pk, sk: client.value.sk }));
	}

	getClients() {
		this.subscriptionClient = this.store
			.pipe(select(selectClientState))
			.subscribe(({ clients, loadingModule }) => {
				this.i++;
				let temporalClient = this.client;
				let temporalModule = this.moduleSelect;

				if (this.clients.length > 0) {
					this.clients = this.clients.map((items) => {
						const clientItem = clients.find(
							(client) => client.pk === items.pk && client.sk === items.sk
						);
						return {
							...items,
							module: clientItem?.module || [],
						};
					});
					this.cdr.detectChanges();
				} else {
					this.clients = clients.length > 0 ? [...clients] : []; //Asigno clientes
					this.cdr.detectChanges();
				}
				if (this.data.type === 'update' && this.i === 2) {
					this.client =
						this.clients.find((item) => item.pk === this.data.value.clientPk) || ({} as Client);
					temporalClient = this.client;
					this.cdr.detectChanges();
					this.store.dispatch(getModuleOneClient({ pk: this.client?.pk, sk: this.client?.sk }));
				}

				this.client =
					this.clients.find(
						(item) => item.pk === temporalClient?.pk && item.sk === temporalClient?.sk
					) || ({} as Client);

				this.cdr.detectChanges();

				const modules = this.client?.module || [];
				this.moduleSelect = modules.find(
					(mod) => mod.modulePk === temporalModule?.modulePk
				) as ModuleClient; //En caso tal haya seleccionado un modulo actualizar la variable
				const data = this.moduleSelect?.dataResources?.resource || [];
				this.paginationResource = this.moduleSelect?.dataResources?.pagination;
				this.loadingResources = loadingModule;
				if (!loadingModule) {
					data.forEach((element) => {
						const rosource = this.resources.find(
							(elementResource) =>
								elementResource.sk === element.sk && elementResource.pk === element.pk
						);
						const resourceUpdate = this.listResources.find(
							(elementResource) =>
								elementResource.sk === element.sk && elementResource.pk === element.pk
						);
						if (!rosource?.sk && !resourceUpdate?.sk) {
							this.resources = [...this.resources, element];
						}
					});
					if (
						this.resources.length < 10 &&
						this.paginationResource?.next &&
						!this.getFullDataResource
					) {
						this.getFullDataResource = true;
						const url =
							this.moduleSelect.relationships.self +
							`?_size=20&_page=${this.paginationResource.next}`;
						this.store.dispatch(
							getResourcesModuleClient({
								url,
								pkClient: this.client.pk,
								skClient: this.client.sk,
							})
						);
					}
				}
			});
	}

	save() {
		if (!this.formRole.invalid && !this.validateClient(this.client)) {
			const resources: IPkSk[] = this.listResources.map((resource) => {
				return { pk: resource.pk, sk: resource.sk };
			});
			const role: IRole = {
				name: this.formRole.value.name,
				description: this.formRole.value.description,
				resources: resources,
				client: this.client.pk,
			} as IRole;
			if (this.data.type === 'update') {
				this.store.dispatch(
					updateRole({ role, id: { pk: this.data.value.pk, sk: this.data.value.sk } })
				);
			} else {
				this.store.dispatch(postRole({ role }));
			}
			this.onNoClick();
		}
	}

	validateClient(client: Client) {
		return JSON.stringify(client) === '{}' ? true : false;
	}

	search(search: string) {
		this.resources = [];
		this.store.dispatch(
			getClientResourcesSearchModule({
				url: `${this.moduleSelect.relationships.self}?_size=20&_page=1&_name=`,
				search,
				pkClient: this.client.pk,
				skClient: this.client.sk,
			})
		);
		this.isModeSearch = search.length > 0 ? true : false;
	}

	validateRouces() {
		if (this.data.type === 'update') {
			const resourcesData: IPkSk[] = this.data.value.resources;
			resourcesData.forEach((resourceId) => {
				this.searchResourcesService
					.getResource(resourceId.pk, resourceId.sk)
					.toPromise()
					.then((resources) => {
						if (resources) {
							this.listResources.push(resources);
							this.listResources = [...this.listResources];
						}
					});
			});
		}
	}

	deleteResource(resource: Resource) {
		const resourceIndex = this.listResources.findIndex(
			(resouceId) => resouceId.pk === resource.pk && resouceId.sk === resource.sk
		);
		this.listResources.splice(resourceIndex, 1);
		this.listResources = [...this.listResources];
		this.resources.push(resource);
		this.resources = [...this.resources];
	}

	addResource(resource: Resource) {
		const resultResource = this.listResources.find(
			(resouceId) => resouceId.pk === resource.pk && resouceId.sk === resource.sk
		);
		if (!resultResource) {
			this.listResources.push(resource);
			this.listResources = [...this.listResources];
			const indexResource = this.resources.findIndex(
				(itemResource) => itemResource.pk === resource.pk && itemResource.sk === resource.sk
			);

			this.resources = [...this.resources];
			this.resources.splice(indexResource, 1);
			this.resources = [...this.resources];

			if (this.resources.length < 5 && this.paginationResource?.next) {
				const url =
					this.moduleSelect.relationships.self + `?_size=20&_page=${this.paginationResource.next}`;
				this.store.dispatch(
					getResourcesModuleClient({
						url,
						pkClient: this.client.pk,
						skClient: this.client.sk,
					})
				);
			}
		}
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.roles.modalRoles;
		});
	}

	onScroll() {
		if (this.paginationResource.next) {
			const url =
				this.moduleSelect.relationships.self + `?_size=20&_page=${this.paginationResource.next}`;
			this.store.dispatch(
				getResourcesModuleClient({
					url,
					pkClient: this.client.pk,
					skClient: this.client.sk,
				})
			);
		}
	}
	onNoClick(): void {
		this.dialogRef.close();
	}

	ngOnDestroy() {
		this.subscriptionClient?.unsubscribe();
		this.subscriptionModule?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
